import axios from "axios";
import { BASE_URL, BASE_URLS, SHOP_ID, SHOP_IDS } from "../const";
import { getCookie, getLocalStorage } from "utils";

const axiosBase = axios.create({
  withCredentials: false,
});
axiosBase.defaults.baseURL = `${window.location.protocol}//${
  BASE_URLS[window.location.host] || BASE_URL
}/`;
// axiosBase.defaults.baseURL = `${window.location.protocol}//${BASE_URL}`;
axiosBase.defaults.timeout = 300000;
axiosBase.interceptors.request.use((request) => {
  request.headers["Content-Type"] = "application/json";
  if (request.method !== "get") {
    const CustomerID = getCookie("CustomerID") || getLocalStorage("CustomerID");
    const Checksum = getCookie("Checksum") || getLocalStorage("Checksum");
    request.headers["Authorization"] = btoa(CustomerID) + "." + Checksum;

    // request.headers["Shop"] = SHOP_IDS[window.location.host] || SHOP_ID;
    // request.headers["CustomerID"] = CustomerID;
    // request.headers["Checksum"] = Checksum;
  }
  return request;
});

axiosBase.interceptors.response.use(
  (response: any) => {
    try {
      if (response?.data?.code !== 1000) {
        return Promise.reject({
          code: response?.data?.code,
          message: response?.data?.message,
        });
      }
      return response;
    } catch (err) {
      return Promise.reject({
        code: response?.data?.code || 1001,
        message: response?.data?.message || "Đã xẩy ra lỗi!",
      });
    }
  },

  (error) => {
    error.message = error.message.toLowerCase().replace(" ", "_");
    if (error.response) {
      return Promise.reject(error.response.data);
    }
    return Promise.reject(error);
  }
);

export default axiosBase;
